module.exports = __webpack_public_path__ + "static/media/Check.2bdd7dc5.mp3";